import AppConstants from '../../Constants/AppConstants';

const checkoutDraftKey = form =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:checkout-settings:${form}`;

export const readCheckoutSettingsDraft = form => {
  try {
    const value = window.localStorage.getItem(checkoutDraftKey(form));
    const draft = value ? JSON.parse(value) : {};
    return draft && typeof draft === 'object' ? draft : {};
  } catch (error) {
    return {};
  }
};

export const writeCheckoutSettingsDraft = (form, values) => {
  try {
    window.localStorage.setItem(checkoutDraftKey(form), JSON.stringify(values));
  } catch (error) {
    // Keep the settings form usable when browser storage is unavailable.
  }
};

export const clearCheckoutSettingsDraft = form => {
  try {
    window.localStorage.removeItem(checkoutDraftKey(form));
  } catch (error) {
    // Ignore storage errors after a successful save.
  }
};
